import { Card } from "antd";
import type { CardProps } from "antd";

export type UICardProps = CardProps;

export const UICard = (props: UICardProps) => <Card {...props} />;
